import { useDispatch } from "react-redux"
import { ChevronRight } from "lucide-react"
import { toogleSideBar } from "../../../../state/actions/layout"
import { memo } from "react";


const SideIconComponent = ({ isMobile, isSideBar }) => {
  const dispatch = useDispatch();

  const commonClasses = "w-8 h-6 rounded-e-20 rounded-el-20 absolute bottom-2 z-50 flex items-center justify-end pe-1 cursor-pointer"

  const style = (isMobile || isSideBar)
    ? `bg-primary-blue -right-6 ${commonClasses}`
    : `bg-white rotate-180 -right-1 ${commonClasses}`

  const iconClass = (isMobile || isSideBar)
    ? "size-4 right-3"
    : "size-4 right-3 text-primary-blue"

  return (
    <span className={style} onClick={() => dispatch(toogleSideBar())}>
      <ChevronRight className={iconClass} />
    </span>
  )
};

export default memo(SideIconComponent)
